import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

import { addMenuToFirebase, updateMenuToFirebase } from '../../firebase/api';
import RecipeList from '../RecipeList';

const useStyles = makeStyles({
  rootPaper: {
    width: 500,
  },
});

export default function CheckListDialog({
  open,
  onClose,
  title,
  content,
  label,
  nextButton,
  cancleButton,
  defaultValue = '',
  defaultPrice = 0,
  defaultContent = '',
  type,
  editedKey,
  ...props
}) {
  const [menuName, setMenuName] = useState('');
  const [contentName, setContentName] = useState('');
  const [price, setPrice] = useState(0);
  const [changeNameListener, setChangeNameListener] = useState(false);
  const [changeContentListener, setChangeContentListener] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setMenuName(defaultValue);
    setPrice(defaultPrice);
    setContentName(defaultContent);
  }, [defaultValue, defaultPrice, defaultContent]);
  const [draftedRecipe, setDraftedRecipe] = useState([]);
  const handleClickCheckbox = useCallback(
    (checked, value) => {
      if (!checked) {
        setDraftedRecipe(draftedRecipe.filter(({ recipeId }) => recipeId !== value.recipeId));
      } else {
        setDraftedRecipe([
          ...draftedRecipe,
          {
            recipeTitle: value.recipeTitle,
            recipeCost: Number(value.recipeCost.replace(/[^0-9]/gi, '')),
            recipeMaterial: value.recipeMaterial,
            recipeId: value.recipeId,
          },
        ]);
      }
    },
    [draftedRecipe]
  );

  const handleUpdateMenu = () => {
    if (type === 'edit') {
      updateMenuToFirebase({ name: menuName, price: price, content: contentName, key: editedKey });
    } else {
      console.log(draftedRecipe);
      draftedRecipe.map((data) => {
        setMenuName(data.recipeTitle);
        setPrice(data.recipeCost);
        setContentName(data.recipeMaterial);
        addMenuToFirebase({ name: data.recipeTitle, price: data.recipeCost, content: data.recipeMaterial });
      });
    }
    onClose();
    // setMenuName('');
    // setPrice(0);
    // setContentName('');
    setDraftedRecipe([]);
  };

  return (
    <div>
      <Dialog classes={{ paper: classes.rootPaper }} open={open} onClose={onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
          <RecipeList onClickCheckbox={handleClickCheckbox} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            {cancleButton}
          </Button>
          <Button onClick={handleUpdateMenu} disabled={draftedRecipe.length === 0} color="primary">
            {nextButton}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
